import { TIER_LABEL, type MaterialDto, type Tier } from '@ads/shared';

/* Peças comuns ao preenchimento e à análise dos Diferenciais. */

/** Os arquivos de evidência de cada diferencial, pelo id. */
export type DiffFiles = Map<string, MaterialDto[]>;

/** Um número com a cor da faixa: atributo comum, possível diferencial, diferencial forte. */
export function Pill({ value, tier, max, big }: { value: number; tier: Tier; max?: number; big?: boolean }) {
  return (
    <span className={`tpill t-${tier}${big ? ' big' : ''}`} title={TIER_LABEL[tier]}>
      <b>{value}</b>{max ? <small>/{max}</small> : null}
    </span>
  );
}
